import React, { ChangeEvent } from 'react'
import SuperSelect from '../../../hw07/common/c5-SuperSelect/SuperSelect'
import {Pagination} from '@mui/material'
import s from './SuperPagination.module.css'

export type SuperPaginationPropsType = {
    id?: string
    page: number
    itemsCountForPage: number
    totalCount: number
    onChange: (page: number, count: number) => void
}

const SuperPagination: React.FC<SuperPaginationPropsType> = (
    {
        page, itemsCountForPage, totalCount, onChange, id = 'hw15',
    }
) => {
    const lastPage = Math.floor(totalCount / itemsCountForPage) // пишет студент // вычислить   количество страниц - ok

    const onChangeCallback = (event: ChangeEvent<unknown>, selectedPage: number) => {
        // пишет студент - ok
        event.preventDefault();
        if (selectedPage !== page && selectedPage >= 1 && selectedPage <= lastPage) {
          onChange(selectedPage, itemsCountForPage)
        }
    }

    const onChangeSelect = (event: ChangeEvent<HTMLSelectElement>) => {
        // пишет студент - ok
        event.preventDefault();
        const selectedItemsQuantity =  Number(event.target.value);
        onChange(page, selectedItemsQuantity)
    }

    return (
        <div className={s.pagination}>
            <Pagination
                id={id + '-pagination'}
                sx={{
                    // стили для Pagination // пишет студент
                  textTransform: 'capitalize',
                  fontFamily: 'Roboto, sans-serif',
                  fontSize: '14px',
                  padding: '0',
                  marginRight: '12px',
                }}
                color="primary"
                shape="rounded"
                page={page}
                count={lastPage}
                onChange={onChangeCallback}
                hideNextButton
                hidePrevButton
            />

            <span className={s.text1}>
                показать
            </span>

            <SuperSelect
                id={id + '-pagination-select'}
                value={itemsCountForPage}
                options={[
                    {id: 4, value: 4},
                    {id: 7, value: 7},
                    {id: 10, value: 10},
                ]}
                onChange={onChangeSelect}
            />

            <span className={s.text2}>
                строк в таблице
            </span>
        </div>
    )
}

export default SuperPagination
